import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=56158d2c&scoped=true&"
import script from "./Policies.vue?vue&type=script&lang=js&"
export * from "./Policies.vue?vue&type=script&lang=js&"
import style0 from "./Policies.vue?vue&type=style&index=0&id=56158d2c&scoped=true&lang=css&"
import style1 from "./Policies.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56158d2c",
  null
  
)

export default component.exports